export class CoCotizaciondetallePk {
    companiasocio: string;
    numerodocumento: string;
    tiporegistro: string;
    linea: number;
}
export class CoCotizaciondetalle {
    pk: CoCotizaciondetallePk;
    constructor() {
        this.pk = new CoCotizaciondetallePk();
    }

    referenciasecuencia: number;
    tipodetalle: string;
    itemcodigo: string;
    descripcion: string;
    unidadcodigo: string;
    cantidadpedida: number;
    preciounitario: number;
    monto: number;
    unidadcodigodoble: string;
    cantidadpedidadoble: number;
    igvexoneradoflag: string;
    documentorelacionadonumero: string;
    documentorelacionadosecuencia: number;
    estado: string;
    ultimousuario: string;
    ultimafechamodif: Date;
    porcentajedescuento01: number;
    porcentajedescuento02: number;
    porcentajedescuento03: number;
    porcentajedescuento04: number;
    preciounitariooriginal: number;
    marca: string;
    dias: string;
    descuento04flag: string;
    transferenciagratuitaflag: string;
    preciounitariogratuito: number;
    margen: number;
    vobomargenflag: string;
    porcentajedescuento05: number;
    lineaitemprincipal: number;
    ordenitemprincipal: number;
    costounitario: number;
    cadena: string;
    cadenabonif: string;
    stockActual: number;
    stockDisponible: number;
    costoTotal: number;
    cantidad: number;
    secuencia: number;
    linea: string;
    limiteMargen: number;
    montoSinDscto: number;
    familia: string;
    subfamilia: string;
    subfamiliainferior: string;
    claselinea: string;
    itemPrecioCodigo: string;
    porcentajedescuento03_Valid: number;
    porcentajedescuento04_Valid: number;
    porcentajedescuento02_Valid: number;
    tipoRegistro: string;
    indbonificacion: string;
    editPrice: string;
    fila: number;
    cantBonificacion: number;
    filaSecuencia: number;

}
